import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { EvmAddressSummaryInfo, EvmTrxSummaryInfo } from '~/api/repository'
import { transactionSummaryKey } from '~/api/service/query-keys.const'

export const useFetchTransactionSummary = (size: number) => {
  return useQuery([ ...transactionSummaryKey, size ], (): Promise<Array<ViewTrxSummaryInfo>> => {
    return explorerApi.trxController.getTrxSummaryList({
      requestBody: {
        size: size
      }
    }).then((res) => {
      return transactionSummaryDto(res as Array<EvmTrxSummaryInfo>)
    })
  })
}

export type ViewTrxSummaryInfo = EvmTrxSummaryInfo & {
  transactionHash: string;
  addressFromInfo: EvmAddressSummaryInfo;
  addressToInfo: EvmAddressSummaryInfo;
  value: string;
}

const transactionSummaryDto = (list: Array<EvmTrxSummaryInfo>): Array<ViewTrxSummaryInfo> => {
  return {
    ...list.map((trx: EvmTrxSummaryInfo) => {
      return {
        ...trx,
        transactionHash: trx.TRXHA,
        addressFromInfo: trx.ADDRSFROMINFO,
        addressToInfo: trx.ADDRSTOINFO,
        value: setComma(trx.VAL),
      }
    })
  }
}